module.exports = __webpack_public_path__ + "img/premiation-2-smartwatch.b47c27da.png";